import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {useMultiStyleConfig, VStack} from '@chakra-ui/react'
import BenefitCard from './benefit-card'
import {GuaranteedIcon, ShippingIcon, ReturnIcon} from '../icons'
import {BRAND_KEY} from '../../brand'

const Benefits = () => {
    const styles = useMultiStyleConfig('Benefits')
    const intl = useIntl()

    return (
        <VStack {...styles.benefitStack}>
            <BenefitCard
                icon={<ShippingIcon {...styles.icon} />}
                infoPopoverTitle={intl.formatMessage({
                    id: 'shipping_services.info.popover.free_delivery.title',
                    defaultMessage: 'Delivery',
                })}
                infoPopoverDescription={intl.formatMessage({
                    id: 'shipping_services.info.popover.free_delivery.description',
                    defaultMessage: 'Delivery Description',
                })}
            >
                {BRAND_KEY === 'kenwood' ? (
                    <FormattedMessage
                        id="shipping_services.label.free_delivery.kenwood"
                        defaultMessage="Free delivery in 1-3 days over {x}"
                        values={{x: 25}}
                    />
                ) : (
                    <FormattedMessage
                        id="shipping_services.label.free_delivery"
                        defaultMessage="Free delivery in 1-3 days over {x}"
                        values={{x: 30}}
                    />
                )}
            </BenefitCard>
            <BenefitCard
                icon={<ReturnIcon {...styles.icon} />}
                infoPopoverTitle={intl.formatMessage({
                    id: 'shipping_services.info.popover.free_returns.title',
                    defaultMessage: 'Return',
                })}
                infoPopoverDescription={intl.formatMessage({
                    id: 'shipping_services.info.popover.free_returns.description',
                    defaultMessage: 'Return Description',
                })}
            >
                <FormattedMessage
                    id="shipping_services.label.free_returns"
                    defaultMessage="Free return up to {x} days"
                    values={{x: 30}}
                />
            </BenefitCard>
            <BenefitCard
                icon={<GuaranteedIcon {...styles.icon} />}
                infoPopoverTitle={intl.formatMessage({
                    id: 'shipping_services.info.popover.garanzia.title',
                    defaultMessage: 'Guarantee',
                })}
                infoPopoverDescription={intl.formatMessage({
                    id: 'shipping_services.info.popover.garanzia.description',
                    defaultMessage: 'Guarantee Description',
                })}
            >
                <FormattedMessage
                    id="shipping_services.label.garanzia"
                    defaultMessage="Full manufacturer warranty"
                />
            </BenefitCard>
        </VStack>
    )
}

export default Benefits
